import { CustomerRFQPage } from "./CustomerRFQPage/CustomerRFQPage";

export default CustomerRFQPage;
